export class ListGoogleWorkspaceGroups200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "groups",
            "baseName": "groups",
            "type": "Array<GoogleWorkspaceGroup>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGoogleWorkspaceGroups200Response.attributeTypeMap;
    }
    constructor() {
    }
}
